// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 40px;
  position: absolute;
  width: 100%;
  height: 12vh;
  box-sizing: border-box;
  align-items: center;
}
#header.home-header{
  height: auto;
  align-items: flex-start;
  padding-top: 50px;
}

#header a {
  text-decoration: none;
  cursor: pointer;
  color: #ffffff;
  opacity: 0.9;
}

#header a:hover {
  opacity: 1;
}

#header .brand-name {
  display: flex;
  align-items: center;
}

#header .brand-name a {
  font-family: 'Cinzel';
  font-size: 22px;
  text-decoration: none;
  cursor: pointer;
  color: #ffffff;
}

#header .link {
  margin-right: 30px;
}

#header img {
  height: 40px;
  width: 40px;
  cursor: pointer;
  opacity: 0.9;
}

#header img:hover {
  opacity: 1;
}

.header-modal .modal-link-container {
  width: 85%;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.header-modal .modal-link {
  text-decoration: none;
  color: #ffffff;
  font-size: 48px;
  font-weight: 700;
  opacity: 0.8;
}

.header-modal .modal-link:hover {
  opacity: 1;
}

.header-modal img {
  position: absolute;
  top: 5%;
  right: 8%;
  height: 60px;
  cursor: pointer;
  opacity: 0.8;
}

.header-modal img:hover {
  opacity: 1;
}

.header-modal .modal-link-grey {
  text-decoration: none;
  color: #ffffff;
  font-size: 48px;
  font-weight: 700;
}

.header-modal .modal-link-grey:hover {
  color: #767676;
}

#mobile-resources {
  cursor: pointer;
}

.resource-menu {
  top: 8vh !important;
}

.resource-menu .resource-item {
  white-space: normal;
  color: #606060;
  font-weight: bold;
}

.resource-menu .resource-item:hover {
  color: #000078;
}

@media (max-width: 768px) {
  #header img {
    margin-left: auto;
  }
}

#header .home-logo{
}
#header .home-logo a{
  opacity: 1;
  display: block;
}
#header .home-logo img{
  width: 140px;
  height: 140px;
  opacity: 1;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./client/styles/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;AACA;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,iBAAiB;AACnB","sourcesContent":["#header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 20px 40px;\n  position: absolute;\n  width: 100%;\n  height: 12vh;\n  box-sizing: border-box;\n  align-items: center;\n}\n#header.home-header{\n  height: auto;\n  align-items: flex-start;\n  padding-top: 50px;\n}\n\n#header a {\n  text-decoration: none;\n  cursor: pointer;\n  color: #ffffff;\n  opacity: 0.9;\n}\n\n#header a:hover {\n  opacity: 1;\n}\n\n#header .brand-name {\n  display: flex;\n  align-items: center;\n}\n\n#header .brand-name a {\n  font-family: 'Cinzel';\n  font-size: 22px;\n  text-decoration: none;\n  cursor: pointer;\n  color: #ffffff;\n}\n\n#header .link {\n  margin-right: 30px;\n}\n\n#header img {\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n#header img:hover {\n  opacity: 1;\n}\n\n.header-modal .modal-link-container {\n  width: 85%;\n  height: 60%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.header-modal .modal-link {\n  text-decoration: none;\n  color: #ffffff;\n  font-size: 48px;\n  font-weight: 700;\n  opacity: 0.8;\n}\n\n.header-modal .modal-link:hover {\n  opacity: 1;\n}\n\n.header-modal img {\n  position: absolute;\n  top: 5%;\n  right: 8%;\n  height: 60px;\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.header-modal img:hover {\n  opacity: 1;\n}\n\n.header-modal .modal-link-grey {\n  text-decoration: none;\n  color: #ffffff;\n  font-size: 48px;\n  font-weight: 700;\n}\n\n.header-modal .modal-link-grey:hover {\n  color: #767676;\n}\n\n#mobile-resources {\n  cursor: pointer;\n}\n\n.resource-menu {\n  top: 8vh !important;\n}\n\n.resource-menu .resource-item {\n  white-space: normal;\n  color: #606060;\n  font-weight: bold;\n}\n\n.resource-menu .resource-item:hover {\n  color: #000078;\n}\n\n@media (max-width: 768px) {\n  #header img {\n    margin-left: auto;\n  }\n}\n\n#header .home-logo{\n}\n#header .home-logo a{\n  opacity: 1;\n  display: block;\n}\n#header .home-logo img{\n  width: 140px;\n  height: 140px;\n  opacity: 1;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
